export default "__VITE_ASSET__C$rEzCvo__"